import {Template, WSQCompression, AppUI, AsThreshold} from "@identy/identy-finger";

export interface TemplateOption {
  name: string;
  selected: boolean;
  template: Template;
}

export interface CompressionOption {
  name: string;
  selected: boolean;
  compression: WSQCompression;
}

export interface AppUiOption {
  name: string;
  selected: boolean;
  appui: AppUI;
}

export interface AsThreshOption {
  name: string;
  selected: boolean;
  threshold: AsThreshold;
}

export interface BackendOption {
  name: string;
  selected: boolean;
  backend: Backend;
}

export enum Backend {
  CPU = "cpu",
  WEBGL = "webgl",
  WASM = "wasm"
}
